export const deforestationLegend = [
  {
    color: '#f8fb74',
    label: '2004',
  },
  {
    color: '#f7ef65',
    label: '2006',
  },
  {
    color: '#f6d848',
    label: '2008',
  },
  {
    color: '#f3bf2d',
    label: '2010',
  },
  {
    color: '#eea610',
    label: '2012',
  },
  {
    color: '#e58c00',
    label: '2014',
  },
  {
    color: '#d97100',
    label: '2016',
  },
  {
    color: '#c95600',
    label: '2018',
  },
  {
    color: '#b53b00',
    label: '2020',
  },
  {
    color: '#9d1900',
    label: '2022',
  },
]
